export default function CustomerImportHistoryFilters({ filters, onChange, onSubmit, loading }) {
  return (
    <form onSubmit={onSubmit} className="rounded-2xl border border-slate-200 bg-white p-4 shadow-sm">
      <div className="grid gap-3 md:grid-cols-3 lg:grid-cols-4">
        <input
          value={filters.search}
          onChange={(event) => onChange("search", event.target.value)}
          placeholder="Zoek op bestandsnaam of batch-id"
          className="rounded-lg border border-slate-200 px-3 py-2 text-sm"
        />
        <select value={filters.sourceType} onChange={(event) => onChange("sourceType", event.target.value)} className="rounded-lg border border-slate-200 px-3 py-2 text-sm">
          <option value="">Alle bronnen</option>
          <option value="generic_csv">generic_csv</option>
          <option value="moneybird_contacts">moneybird_contacts</option>
          <option value="excel_manual">excel_manual</option>
        </select>
        <select value={filters.status} onChange={(event) => onChange("status", event.target.value)} className="rounded-lg border border-slate-200 px-3 py-2 text-sm">
          <option value="">Alle statussen</option>
          <option value="completed">completed</option>
          <option value="completed_with_errors">completed_with_errors</option>
          <option value="processing">processing</option>
          <option value="failed">failed</option>
        </select>
        <input
          value={filters.createdBy}
          onChange={(event) => onChange("createdBy", event.target.value)}
          placeholder="Aangemaakt door"
          className="rounded-lg border border-slate-200 px-3 py-2 text-sm"
        />
        <input
          type="date"
          value={filters.dateFrom}
          onChange={(event) => onChange("dateFrom", event.target.value)}
          className="rounded-lg border border-slate-200 px-3 py-2 text-sm"
        />
        <input
          type="date"
          value={filters.dateTo}
          onChange={(event) => onChange("dateTo", event.target.value)}
          className="rounded-lg border border-slate-200 px-3 py-2 text-sm"
        />
      </div>
      <div className="mt-3 flex justify-end">
        <button type="submit" disabled={loading} className="rounded-lg bg-slate-900 px-4 py-2 text-sm text-white disabled:opacity-60">
          {loading ? "Laden..." : "Filters toepassen"}
        </button>
      </div>
    </form>
  );
}
